import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Spinner } from 'reactstrap';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import FormSection from '../../../layout/FormSection';
import FileUploader from '../../../shared/FileUploader';
import '../../../shared/FileUploader.css';
import { API, BASE_URL } from '../../../../CONST';
import { fileDownload } from '../../../../helpers/helpers';
import BatchOperationFeedback from '../../../shared/BatchOperationFeedback';

const CreditLineBatchLoad = ({ policyId, handleBatchUploadFinish, errors, setErrors, lineas, setLineas, isCargaMasiva, setIsCargaMasiva, maximoInnominadosAmt, getUmbralMinimo, }) => {
  const loginIdToken = useSelector((state) => state.login.id_token);
  const [isLoading, setIsLoading] = useState(false);

  const handleUploadStart = () => {
    setIsLoading(true);
    setErrors([]);
  };

  const handleUploadFinish = (response) => {
    setIsLoading(false);
    handleBatchUploadFinish(response);
  };

  return (
    <FormSection title="Carga Masiva">
      <Form>
        <FormGroup>
          <FileUploader
            uploadUrl={`${BASE_URL}${API.lineasCreditoBulkUpload}/?poliza_id=${policyId}&preload=True&maximoInnominadosAmt=${maximoInnominadosAmt}&umbralminimo=${getUmbralMinimo}`}
            inputText="Seleccione un archivo (.xlsx)"
            accept=".xls,.xlsx"
            maxFileSize={200 * 1024}
            helpText={(
              <>
                Descargue la plantilla&nbsp;
                <button
                  type="button"
                  className="btn-as-link"
                  onClick={() => fileDownload(`${BASE_URL}${API.lineasCreditoBulkUploadTemplate}/`, loginIdToken)}
                >
                  aquí
                </button>
                .
              </>
            )}
            handleInitUploading={handleUploadStart}
            handleResponse={handleUploadFinish}
            clearable
            onClearFile={() => {
              setErrors([]);
              setLineas((prevLineas) => prevLineas.filter((linea) => "estado_data" in linea));
              setIsCargaMasiva(false);
            }}
          />
          {isLoading && (
            <div className="text-center my-3">
              <Spinner style={{ width: '3rem', height: '3rem' }} />
            </div>
          )}
          {isCargaMasiva && lineas.length > 0 && errors.length === 0 && (
            <div className="orsan-value" style={{ fontSize: '1rem', marginTop: '16px' }}>
              <>
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  style={{ color: '#23C21D', fontSize: '1rem', marginRight: '5px' }}
                />
                Carga exitosa.
              </>
            </div>
          )}
          {isCargaMasiva && lineas.length > 0 && errors.length > 0 && (
            <div className="orsan-value" style={{ fontSize: '1rem', marginTop: '16px' }}>
              <>
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  style={{ color: '#FCBA03', fontSize: '1rem', marginRight: '5px' }}
                />
                Carga exitosa pero con algunos errores.
              </>
            </div>
          )}
        </FormGroup>
      </Form>
      {errors.length > 0 && (
        <BatchOperationFeedback errors={errors} setErrors={setErrors} />
      )}
    </FormSection>
  );
};

CreditLineBatchLoad.propTypes = {
  policyId: PropTypes.string.isRequired,
  handleBatchUploadFinish: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.number,
      message: PropTypes.string,
    })
  ).isRequired,
  setErrors: PropTypes.func.isRequired,
  lineas: PropTypes.arrayOf(PropTypes.object).isRequired,
  setLineas: PropTypes.func.isRequired,
  isCargaMasiva: PropTypes.bool.isRequired,
  setIsCargaMasiva: PropTypes.func.isRequired,
  maximoInnominadosAmt: PropTypes.number,
};

export default CreditLineBatchLoad;
